import axios from "axios";

const API_BASE = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
    baseURL: `${API_BASE}/api`,
    headers: { "Content-Type": "application/json" },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("biro_token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Handle 401 responses
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401 && window.location.pathname.startsWith("/admin")) {
            localStorage.removeItem("biro_token");
            window.location.href = "/admin/login";
        }
        return Promise.reject(error);
    }
);

export default api;
export { API_BASE };
